import * as React from 'react';
import { SVGProps } from 'react';

const SvgOnlinePrototyping = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15.473 12.5V9l-5.229 3.588M10.221 16.314 20.737 9v3.76'
      stroke='#000'
      strokeWidth={0.75}
    />
    <path
      d='M10.21 8h.375v-.375h-.375V8ZM6 8v-.375h-.375V8H6Zm4.21 12.053h-.374v.72l.59-.413-.216-.307ZM26 9h.375v-.72l-.59.413L26 9Zm0 15v.375h.375V24H26Zm-6 0h-.375v.375H20V24Zm0-5h.375v-.375H20V19Zm-3 0v-.375h-.375V19H17Zm0 5v.375h.375V24H17ZM6 24h-.375v.375H6V24Zm4.21-16.375H6v.75h4.21v-.75Zm.375 12.428V8h-.75v12.053h.75Zm15.2-11.36L9.995 19.746l.43.614 15.79-11.053-.43-.614ZM26.375 24V9h-.75v15h.75ZM20 24.375h6v-.75h-6v.75ZM19.625 19v5h.75v-5h-.75ZM17 19.375h3v-.75h-3v.75ZM17.375 24v-5h-.75v5h.75ZM6 24.375h11v-.75H6v.75ZM5.625 24h.75-.75Zm0-1v1h.75v-1h-.75Zm0-15v15h.75V8h-.75Z'
      fill='#000'
    />
    <path stroke='#000' d='M10 10.5H6' />
  </svg>
);

export default SvgOnlinePrototyping;
